// @ts-nocheck
/* Port of views/dashboard/module/AgentEditAclModal.js — byte-identical. */
import React, { useEffect, useState } from 'react';
import { AGENT_EDIT_OPTION_DEFS, normalizeAgentEditOptions } from '@/utilities/agentAcl';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
  FaUser,
} from '@/features/acl-settings/aclSettingsUi';

const AgentEditAclModal = ({
  show,
  onHide,
  initialOptions = [],
  onSave,
  optionDefs = AGENT_EDIT_OPTION_DEFS,
  limitedByParent = false,
}) => {
  const [selected, setSelected] = useState([]);
  const optionValues = optionDefs.map((o) => o.value);

  useEffect(() => {
    if (show) {
      const fromInitial = normalizeAgentEditOptions(initialOptions).filter((v) => optionValues.includes(v));
      const defaults = optionDefs.filter((o) => o.defaultOn !== false).map((o) => o.value);
      setSelected(fromInitial.length > 0 ? fromInitial : defaults);
    }
  }, [show, initialOptions, optionDefs]);

  const toggle = (value) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const handleReset = () => setSelected([]);

  const handleSave = () => {
    onSave(selected);
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Agents — Edit Options"
      icon={FaUser}
      description="Select which agent settings users with this ACL can change when creating or editing an agent. Includes telephony types (Mobile, Soft Phone, WEBRTC)."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={selected.length === 0 || optionDefs.length === 0}
    >
      <AclModalSection
        icon={FaUser}
        title="Agent Settings"
        subtitle="Choose options allowed when creating or editing agents."
      >
        {optionDefs.length === 0 ? (
          <p className="acl-modal-empty">
            You do not have permission to grant any agent edit options.
          </p>
        ) : (
          optionDefs.map((opt) => (
            <AclModalOptionCheck
              key={opt.value}
              id={`agent-edit-${opt.value}`}
              label={opt.label}
              description={opt.description}
              checked={selected.includes(opt.value)}
              onChange={() => toggle(opt.value)}
            />
          ))
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default AgentEditAclModal;
